const discoverEN = {
  loading: "Loading…",
  toolbar: {
    filters: "⚙︎ Filters",
    sortBy: "Sort by:",
    showMap: "Show map",
    recommended: "Recommended",
  },
  sort: {
    distance: "Distance",
    highestRated: "Highest rated",
    lowestRated: "Lowest rated",
    recommended: "Recommended"
  },
  title: "Shops",
  subtitle: "What affects the search results?",
  reviews: "reviews",
  shop: {
    untitled: "Untitled Shop",
  },
  services: {
    book: "Book",
    more: (count) => `+${count} more services`,
  },
  empty: "No shops found.",
};

export default discoverEN;
